import { Injectable, NgZone } from '@angular/core';
import { of, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Tokens } from '../models/tokens';
import { AlertModalService } from './../../../shared/alert-modal.service';
import { LoginService } from './../../../api/login.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })

export class AuthService {

  checkTokenAccess = false;
  checkToken = null;
  systemVersion: string;

  private jwtHelper = new JwtHelperService();
  private expirationTimer: any;

  private readonly errorMessage = 'Ocorreu um erro de rede durante sua solicitação de login. Tente novamente. Se essa condição persistir, contate o provedor de serviços de rede.';
  private readonly JWT_TOKEN = 'token';

  constructor(
    private alertService: AlertModalService,
    private router: Router,
    private ngZone: NgZone,
    private route: ActivatedRoute,
    private loginService: LoginService) {}

  public sysVersion() {
    return this.systemVersion = this.loginService.systemVersion();
  }

  public isLoggedIn() {
    return !!this.getJwtToken();
  }

  post(user: { userName: string, password: string }): Observable<boolean> {
    return this.loginService.v1LoginPost(user)
      .pipe(
        tap(success => {
          // if (!token.authenticated) {
          if (!success.accessToken) {
            if (success.message === 'Falha ao autenticar') {
              this.alertService.showAlertDanger('Login inválido. Tente novamente.');
            } else {
              this.alertService.showAlertDanger(success.message + '!');
            }
          } else {
            this.doLoginUser(success);
          }
        }),
        catchError(error => {
          console.error('Erro: ', error);
          // if(error.Erros[0]?.Mensagem) {
          //   console.error('Detalhes do erro: ', error.Erros[0]?.Mensagem);
          //   this.alertService.showAlertDanger(error.Erros[0]?.Mensagem + '!');
          // } else {
          //   this.alertService.showAlertDanger(this.errorMessage);
          // }
          return of(false);
        }));
  }

  logout() {
    this.removeTokens();
  }

  getJwtToken() {

    const hasToken = localStorage.getItem(this.JWT_TOKEN);

    // Valida se o token realmente existe e não é uma string corrompida ("null" / "undefined")
    if (!hasToken || hasToken === 'null' || hasToken === 'undefined' || hasToken.trim() === '') {
      return undefined;
    }

    try {
      // Só tenta checar a expiração se passar na validação acima
      const checkTokenExpired = this.jwtHelper.isTokenExpired(hasToken);
      return checkTokenExpired ? undefined : hasToken;
    } catch (error) {
      // Se o token estiver malformado por qualquer outro motivo, captura o erro de forma segura
      console.error("Erro ao decodificar o token JWT armazenado:", error);
      return undefined;
    }
  }

  private doLoginUser(tokens: Tokens) {
    this.checkToken = tokens.accessToken;
    if (this.checkToken) {
      this.checkTokenAccess = true;
      this.storeTokens(tokens);
    } else {
      this.removeTokens();
    }
  }

  private storeTokens(tokens: Tokens) {
    localStorage.setItem(this.JWT_TOKEN, tokens.accessToken);
    localStorage.setItem('_date', tokens.expiraEm.toLocaleString());
  }

  checarCronometroToken() {
    const token = this.getJwtToken();
    if (!token) return;

    // 1. Descobre em quantos milissegundos o token vai expirar
    const expirationDate = this.jwtHelper.getTokenExpirationDate(token);
    const tempoRestante = expirationDate.getTime() - Date.now();

    // Limpa qualquer timer rodando antes
    if (this.expirationTimer) clearTimeout(this.expirationTimer);

    // 2. Cria o temporizador para deslogar exatamente quando vencer
    this.expirationTimer = setTimeout(() => {
      this.ngZone.run(() => {
        console.warn('O tempo do Token acabou! Deslogando automaticamente...');
        // ✅ 1. CAPTURA A ROTA EXATA ONDE O USUÁRIO ESTAVA TRAVADO
        const currentUrl = this.router.url;

        // 2. Limpa os dados do localStorage
        this.logout();

        // ✅ 3. REDIRECIONA PASSANDO A URL COLETADA COMO PARAMÊTRO
        this.router.navigate(['/login'], { queryParams: { returnUrl: currentUrl } });

      });
    }, tempoRestante);
  }

  private removeTokens() {
    this.checkTokenAccess = false;
    localStorage.clear();
    sessionStorage.clear()
    // this.router.navigate(['/login']);
  }

}

